import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { GeneralService } from '../_service/general.service';

@Injectable()
export class RegistrationGuard {
    constructor(private router: Router, private generalService: GeneralService) {
    }

    public canActivate(): Observable<boolean> {
        return this.generalService.getOrganisationInfo().pipe(
            take(1),
            map(organizationInfo => {
                if (!organizationInfo.isRegistrationPageEnabled) {
                    this.router.navigate(['/login']);
                    return false;
                }
                return true;
            })
        );
    }
}
